




















import {
  defineComponent,
  computed
} from '@vue/composition-api'

import {
  FooterContentAction,
  FooterContentGetter
} from '@/store'

import {
  FooterLink,
  FooterLinkBlock
} from '@/types'

import { RoutePath } from '@/router'

const mapNavigationLink = (link: FooterLink) => ({
  name: link.title,
  href: link.url
    ? link.url
    : `${RoutePath.SimplePage}${link.simplePagePath}`
})

const mapNavigation = (input: FooterLinkBlock) => ({
  header: input.title,
  links: (input.links || []).map(mapNavigationLink)
})

export default defineComponent({
  setup (_, context) {
    const store = context.root.$store

    // get footer contents
    store.dispatch(FooterContentAction.Fetch)

    const loaded = computed(() => store.getters[FooterContentGetter.Loaded])
    const isCurrentRouteLandlord = computed(() => context.root.$route.path.includes(RoutePath.LandlordPage))

    const showFooterList = computed(() => loaded.value && !isCurrentRouteLandlord.value)

    const navigationLinks = computed(() => {
      const footerNavigation = store.getters[FooterContentGetter.Navigation] as FooterLinkBlock[]
      return footerNavigation.map(mapNavigation)
    })

    const legalLinks = computed(() => {
      const footerBottomLinks = store.getters[FooterContentGetter.BottomLinks] as FooterLink[]
      return footerBottomLinks.map(mapNavigationLink)
    })

    return {
      showFooterList,
      loaded,
      navigationLinks,
      legalLinks
    }
  }
})
